import React from 'react'
import {
  Form,
  Modal,
  Table,
} from 'antd'
import jsPDF from 'jspdf'
import html2canvas from 'html2canvas'
import logo from '../static/images/New_logo.jpg'
import axios from 'axios'
import useDownloadPdf from '../hooks/DownloadPdf'
import apiRequest from '../hooks/ApiRequest'
function roundvalue(value) {
  if (value > 0) {
    return parseFloat(value.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0])
  }
}
const productNameInLocalStorage = localStorage.getItem("productName");
const { confirm } = Modal
let clientuuid = ''
class ViewQuotation extends React.Component {
  constructor(props) {
    super(props)
    this.downloadPdf = useDownloadPdf().generatePdf
    this.state = {
      quotationId: localStorage.getItem('quotationId'),
      policyEndDate: '',
      PolicyStartDate: '',
      PolicyAnnualPremium: '',
      totalannualpremium: '',
      clientname: '',
      RefundableAmount: '0.0',
      policyProRataPremium: '',
      policyRiskCover: '',
      policyRiskCoverItems: '',
      totalSumInsured: 0,
      totalProRataPremium: 0,
      grandtotalannualpremium: 0,
      grandtotaltermpremium: 0,
      transactionDate: '',
      currency: '',
      productname: '',
      client_mobile: '',
      client_id_number: '',
      client_address: '',
      client_age: '',
      productId: parseInt(localStorage.getItem('productId')),
      totalMonthlyPremium: 0,
      columns: [
        {
          key: 'riskitem',
          title: 'Risk Item Details',
          dataIndex: 'riskitemname',
        },
        {
          key: 'address',
          title: 'Risk Address',
          dataIndex: 'address',
        },
        {
          key: 'suminsured',
          title: 'Sum Insured',
          dataIndex: 'suminsured',
          render: (suminsured) => { return (parseFloat(suminsured).toFixed(2)) },
        },
        {
          key: 'Proratapremium',
          title: 'Annual Premium (excluding stamp duty)',
          dataIndex: 'annualpremium',
          render: (annualpremium) => { return (parseFloat(annualpremium).toFixed(2)) },
        },
      ],
      columnsForFCP: [
        {
          key: 'relation',
          title: 'Relationship',
          dataIndex: 'relationship',
        },
        {
          key: 'name',
          title: 'Members Name',
          dataIndex: 'membername',
        },
        {
          key: 'gender',
          title: 'Gender',
          dataIndex: 'gender',
        },
        {
          key: 'age',
          title: 'Age',
          dataIndex: 'age',
        },
        ...(parseInt(localStorage.getItem('productId')) === 3) ?
          [{
            key: 'sumInsured',
            title: 'Sum Insured',
            dataIndex: 'suminsured',
            render: (suminsured) => { return (parseFloat(suminsured).toFixed(2)) },
          },
          {
            key: 'rate',
            title: 'Premium Rate',
            dataIndex: 'rate',
            render: (rate) => { return (parseFloat(rate).toFixed(2)) },
          },
          {
            key: 'termpremium',
            title: 'Term Premium',
            dataIndex: 'termpremium',
            render: (termpremium) => { return (parseFloat(termpremium).toFixed(2)) },
          },
          {
            key: 'annualpremium',
            title: 'Premium',
            dataIndex: 'annualpremium',
            render: (annualpremium) => { return (parseFloat(annualpremium).toFixed(2)) },
          },] : [{
            key: 'sumInsured',
            title: 'Sum Insured',
            dataIndex: 'suminsured',
            render: (suminsured) => { return (parseFloat(suminsured).toFixed(2)) },
          },
          {
            key: 'rate',
            title: 'Premium Rate',
            dataIndex: 'rate',
            render: (rate) => { return (parseFloat(rate).toFixed(2)) },
          },
          {
            key: 'termpremium',
            title: 'Term Premium',
            dataIndex: 'termpremium',
            render: (termpremium) => { return (parseFloat(termpremium).toFixed(2)) },
          },
          {
            key: 'annualpremium',
            title: 'Premium',
            dataIndex: 'annualpremium',
            render: (annualpremium) => { return (parseFloat(annualpremium).toFixed(2)) },
          },],

      ],
      data: [],
      status: '',
    }
  }
  componentDidMount() {
    //     working here..
    //debugger

    apiRequest(
      process.env.REACT_APP_BASE_URL +
      '/quotation/GetQuotaionDetailsbyid/' +
      this.state.quotationId, 'GET'
    )
      .then(res => {
        console.log(res.data)
        if (res?.data?.clientdetail?.entitytype !== 'Business') {

          if (res?.data?.clientdetail?.clientfirstname.includes('undefined')) {
            this.setState({
              clientname:
                res.data.clientdetail.clientfirstname.slice(9) +
                ' ' +
                res.data.clientdetail.clientsurname,
              client_mobile: res.data.clientdetail.clientcontactnumber,
              client_address: res.data.clientdetail.clientaddress1,
              client_age: res.data.clientdetail.clientage,
              client_id_number: res.data.clientdetail.nationalid,
              productname: res.data.pquotationdetail.productname,
            })
          } else {
            this.setState({
              clientname:
                res.data.clientdetail.clientfirstname +
                ' ' +
                res.data.clientdetail.clientsurname,
              client_mobile: res.data.clientdetail.clientcontactnumber,
              client_address: res.data.clientdetail.clientaddress1,
              client_age: res.data.clientdetail.clientage,
              client_id_number: res.data.clientdetail.nationalid,
              productname: res.data.pquotationdetail.productname,
            })
          }

        }
        else {

          this.setState({
            clientname: res.data.clientdetail.clientcorporatename,
            client_mobile: res.data.clientdetail.clientcontactnumber,
            client_address: res.data.clientdetail.clientaddress1,
            client_age: res.data.clientdetail.clientage,
            client_id_number: res.data.clientdetail.nationalid,
            productname: res.data.pquotationdetail.productname,
            proratatotaltermpremium: res.data.pquotationdetail.proratatotaltermpremium
          })

        }
        this.setState({ quotationId: res.data.pquotationdetail.id })
        this.setState({
          PolicyStartDate: res.data.pquotationdetail.policystartdate,
        })
        this.setState({
          policyEndDate: res.data.pquotationdetail.policyexpirytdate,
        })
        this.setState({
          PolicyAnnualPremium: res.data.pquotationdetail.totalannualpremium,
        })
        this.setState({ grandtotalannualpremium: res.data.pquotationdetail.grandtotalannualpremium })
        this.setState({ grandtotaltermpremium: res.data.pquotationdetail.grandtotaltermpremium })
        // this.setState({ clientname: res.data.pquotationdetail.clientname })
        this.setState({
          policyProRataPremium: roundvalue(
            res.data.pquotationdetail.grandtotalannualpremium,
          ),
        })

        if (res.data.pquotationdetail.riskitemlist.length > 1) {
          let arr = []
          res.data.pquotationdetail.riskitemlist.forEach(element => {
            arr.push(element.policy_cover)
          })
          var finalResult = arr.join(', ')
          this.setState({
            policyRiskCover: finalResult,
            currency: res.data.pquotationdetail.currency,
          })
        } else {
          this.setState({
            policyRiskCover:
              res.data.pquotationdetail.riskitemlist[0].policy_cover,
            currency: res.data.pquotationdetail.currency,
          })
        }

        //this.setState({
        //policyRiskCover: res.data.pquotationdetail.policyriskcover,
        //  currency: res.data.pquotationdetail.currency,
        //})

        var transaction = res.data.pquotationdetail.createddate.toString()
        var s = transaction.slice(0, 10)
        this.setState({ transactionDate: s })
        if (this.state.productId === 3 || this.state.productId === 5) {
          this.setState({ dataForFcp: res.data.pquotationdetail.riskitemlist })
          for (
            let i = 0;
            i < res.data.pquotationdetail.riskitemlist.length;
            i++
          ) {
            this.state.totalMonthlyPremium +=

              res.data.pquotationdetail.riskitemlist[i].monthlypremium
          }
        } else {
          this.setState({ data: res.data.pquotationdetail.riskitemlist })
        }

        for (
          let i = 0;
          i < res.data.pquotationdetail?.riskitemlist?.length;
          i++
        ) {
          this.state.totalSumInsured =
            this.state.totalSumInsured +
            res.data.pquotationdetail.riskitemlist[i].suminsured
        }
        this.setState({ totalSumInsured: roundvalue(this.state.totalSumInsured) })
      })
    // fetch(process.env.REACT_APP_BASE_URL + '/Client/MasterSetting')
    //   .then(res => res.json())
    //   .then(data => {
    //     this.setState({
    //       productname: data[0].productname,
    //     })
    //   })
  }

  printDocument() {
    //const input = document.querySelector("#divToPrint");
    html2canvas(document.querySelector('#divToPrint')).then(canvas => {
      document.body.appendChild(canvas) // if you want see your screenshot in body.
      const imgData = canvas.toDataURL('image/png')
      const pdf = new jsPDF()
      pdf.addImage(imgData, 'PNG', 0, 0)
      pdf.save('download.pdf')
    })
  }

  render() {
    return (
      <div className="container-box" style={{ marginTop: '15px' }}>
        <div
          className="white-box-bg"
          id="divToPrint"
          style={{ padding: '30px 20px 150px' }}>
          <div style={{ padding: '15px 0', width: '50%' }}>
            <img src={logo} className="logo-img" style={{ width: '250px' }} />
          </div>

          <div style={{ padding: '10px' }}>
            <div>
              <h4
                style={{
                  padding: '5px 2px',
                  fontSize: '14px',
                  fontWeight: '800',
                  margin: '0',
                  textTransform: 'capitalize',
                }}>
                Customer Details
              </h4>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div style={{ width: '50%' }}>
                  <ul
                    style={{
                      padding: '5px 20px 20px 0',
                      fontSize: '14px',
                      color: '#000',
                      fontWeight: '500',
                      margin: '0',
                      listStyle: 'none',
                    }}>
                    <li>Name : </li>
                    <li>Mobile:</li>
                    <li>Address:</li>
                    {productNameInLocalStorage !== 'LEGAL INSURANCE' ? <li>Age:</li> : ""}
                    <li>National Id:</li>
                  </ul>
                </div>
                <div style={{ width: '50%' }}>
                  <ul
                    style={{
                      padding: '5px 20px 20px 0',
                      fontSize: '14px',
                      color: '#000',
                      fontWeight: '500',
                      margin: '0',
                      listStyle: 'none',
                    }}>
                    <li>{this.state.clientname}</li>
                    <li>{this.state.client_mobile}</li>
                    <li>{this.state.client_address}</li>
                    {productNameInLocalStorage !== 'LEGAL INSURANCE' ? <li>{this.state.client_age}</li> : ""}
                    <li>{this.state.client_id_number}</li>
                  </ul>
                </div>
              </div>
            </div>
            <div>
              <h4
                style={{
                  padding: '5px 2px',
                  fontSize: '14px',
                  fontWeight: '800',
                  margin: '0',
                  textTransform: 'capitalize',
                }}>
                Quotation Details
              </h4>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div style={{ width: '50%' }}>
                  <ul
                    style={{
                      padding: '5px 20px 20px 0',
                      fontSize: '14px',
                      color: '#000',
                      fontWeight: '500',
                      margin: '0',
                      listStyle: 'none',
                    }}>
                    <li>Quotation number : </li>
                    {this.state.productId !== 3 && productNameInLocalStorage !== 'LEGAL INSURANCE' ? (
                      <li>Period of Insurance :</li>
                    ) : (
                      <li>Start Date :</li>
                    )}
                    {/* <li>Transaction Date :</li> */}
                    <li>Currency :</li>
                    <li>Annual Premium(including stamp duty)</li>
                    <li>Term Premium(including stamp duty)</li>
                  </ul>
                </div>
                <div style={{ width: '50%' }}>
                  <ul
                    style={{
                      padding: '5px 20px 20px 0',
                      fontSize: '14px',
                      color: '#000',
                      fontWeight: '500',
                      margin: '0',
                      listStyle: 'none',
                    }}>
                    <li>{this.state.quotationId}</li>
                    <li>
                      {this.state.PolicyStartDate}
                      {(this.state.productId !== 3 || this.state.productId !== 5) && productNameInLocalStorage !== 'LEGAL INSURANCE' ? <b> To </b> : ""}
                      {productNameInLocalStorage !== 'LEGAL INSURANCE' ? this.state.policyEndDate : ""}
                    </li>
                    {/* <li>{this.state.transactionDate}</li> */}
                    <li>{this.state.currency}</li>
                    <li>{this.state.grandtotalannualpremium}</li>
                    <li>{this.state.grandtotaltermpremium}</li>
                  </ul>
                </div>
              </div>
            </div>
            <div>
              <h4
                style={{
                  padding: '5px 2px',
                  fontSize: '14px',
                  fontWeight: '800',
                  margin: '0',
                  textTransform: 'capitalize',
                }}>
                Product Details
              </h4>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div style={{ width: '50%' }}>
                  <ul
                    style={{
                      padding: '0 20px 20px 2px',
                      color: '#000',
                      fontSize: '14px',
                      fontWeight: '700',
                      margin: '0',
                      listStyle: 'none',
                    }}>
                    <li>Product :</li>
                  </ul>
                </div>
                <div style={{ width: '50%' }}>
                  <ul
                    style={{
                      padding: '0 20px 20px 2px',
                      color: '#000',
                      fontSize: '14px',
                      fontWeight: '700',
                      margin: '0',
                      listStyle: 'none',
                    }}>
                    <li>{this.state.productname}</li>
                  </ul>
                </div>
              </div>
            </div>
            <div>
              <h4
                style={{
                  padding: '5px 2px',
                  fontSize: '14px',
                  color: '#000',
                  fontWeight: '800',
                  margin: '0',
                  textTransform: 'capitalize',
                }}>
                Risk Cover Details
              </h4>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div style={{ width: '50%' }}>
                  <ul
                    style={{
                      padding: '0 20px 20px 2px',
                      color: '#000',
                      fontSize: '14px',
                      fontWeight: '500',
                      margin: '0',
                      listStyle: 'none',
                    }}>
                    <li>Policy Cover:</li>
                  </ul>
                </div>
                <div style={{ width: '50%' }}>
                  <ul
                    style={{
                      padding: '0 20px 20px 2px',
                      color: '#000',
                      fontSize: '14px',
                      fontWeight: '500',
                      margin: '0',
                      listStyle: 'none',
                    }}>
                    <li>{this.state.policyRiskCover}</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="dataSource-grid">
              <Table rowKey={record => record.id}
                columns={
                  this.state.productId == 3 || this.state.productId == 5
                    ? this.state.columnsForFCP
                    : this.state.columns
                }
                dataSource={
                  this.state.productId == 3 || this.state.productId == 5
                    ? this.state.dataForFcp
                    : this.state.data
                }
                pagination={false}
                footer={() => { parseFloat(this.state.policyProRataPremium).toFixed(2) }}
              />

              {(this.state.productId !== 3 && this.state.productId !== 5) && (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <div
                    style={{
                      width: '25%',
                      textAlign: 'left',
                      padding: '10px  14px',
                    }}>
                    <ul
                      style={{
                        padding: '0 0px 20px 2px',
                        color: '#000',
                        fontSize: '14px',
                        fontWeight: '800',
                        margin: '0',
                        listStyle: 'none',
                      }}>
                      <li>Grand Totals</li>
                    </ul>
                  </div>
                  <div style={{ width: '25%', padding: '10px 16px 14px' }}>
                    <ul
                      style={{
                        padding: '0 0px 20px 2px',
                        color: '#000',
                        fontSize: '14px',
                        fontWeight: '800',
                        margin: '0',
                        listStyle: 'none',
                      }}></ul>
                  </div>

                  {/* <div style={{width: '25%', padding: '10px 16px 14px'}}>
                    <ul
                      style={{
                        padding: '0 0px 20px 2px',
                        color: '#000',
                        fontSize: '14px',
                        fontWeight: '800',
                        margin: '0',
                        listStyle: 'none',
                      }}>
                      <li></li>
                    </ul>
                  </div> */}

                  <div style={{ width: '25%', padding: '10px 16px 14px' }}>
                    <ul
                      style={{
                        padding: '0 0px 20px 2px',
                        color: '#000',
                        fontSize: '14px',
                        fontWeight: '800',
                        margin: '0',
                        listStyle: 'none',
                      }}>
                      <li>{productNameInLocalStorage == 'LEGAL INSURANCE' ? "" : parseFloat(this.state.totalSumInsured).toFixed(2)}</li>
                    </ul>
                  </div>


                  <div style={{ width: '25%', padding: '10px 16px 14px' }}>
                    <ul
                      style={{
                        padding: '0 0px 20px 2px',
                        color: '#000',
                        fontSize: '14px',
                        fontWeight: '800',
                        margin: '0',
                        listStyle: 'none',
                      }}>
                      <li>   {productNameInLocalStorage === 'LEGAL INSURANCE' ? parseFloat(this.state.proratatotaltermpremium).toFixed() : parseFloat(this.state.policyProRataPremium).toFixed(2)}</li>
                    </ul>
                  </div>
                </div>
              )}

              {this.state.productId === 3 || this.state.productId == 5 ? (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <div
                    style={{
                      width: '25%',
                      textAlign: 'left',
                      padding: '10px  14px',
                    }}>
                    <ul
                      style={{
                        padding: '0 0px 20px 2px',
                        color: '#000',
                        fontSize: '14px',
                        fontWeight: '800',
                        margin: '0',
                        listStyle: 'none',
                      }}>
                      <li>Grand Totals</li>
                    </ul>
                  </div>

                  <div style={{ width: '25%', padding: '10px 16px 14px' }}>
                    <ul
                      style={{
                        padding: '0 0px 20px 2px',
                        color: '#000',
                        fontSize: '14px',
                        fontWeight: '800',
                        margin: '0',
                        listStyle: 'none',
                      }}></ul>
                  </div>

                  <div style={{ width: '25%', padding: '10px 16px 14px' }}>
                    <ul
                      style={{
                        padding: '0 0px 20px 2px',
                        color: '#000',
                        fontSize: '14px',
                        fontWeight: '800',
                        margin: '0',
                        listStyle: 'none',
                      }}>
                      <li></li>
                    </ul>
                  </div>

                  <div style={{ width: '25%', padding: '10px 16px 14px' }}>
                    <ul
                      style={{
                        padding: '0 0px 20px 2px',
                        color: '#000',
                        fontSize: '14px',
                        fontWeight: '800',
                        margin: '0',
                        listStyle: 'none',
                      }}>
                      <li></li>
                    </ul>
                  </div>

                  <div style={{ width: '25%', padding: '10px 16px 14px' }}>
                    <ul
                      style={{
                        padding: '0 0px 20px 2px',
                        color: '#000',
                        fontSize: '14px',
                        fontWeight: '800',
                        margin: '0',
                        listStyle: 'none',
                      }}>
                      <li>{this.state.productId === 5 ? "" : parseFloat(this.state.totalSumInsured).toFixed(2)}</li>
                    </ul>
                  </div>

                  <div style={{ width: '25%', padding: '10px 16px 14px' }}>
                    <ul
                      style={{
                        padding: '0 0px 20px 2px',
                        color: '#000',
                        fontSize: '14px',
                        fontWeight: '800',
                        margin: '0',
                        listStyle: 'none',
                      }}>
                      <li></li>
                    </ul>
                  </div>

                  <div style={{ width: '25%', padding: '10px 16px 14px' }}>
                    <ul
                      style={{
                        padding: '0 0px 20px 2px',
                        color: '#000',
                        fontSize: '14px',
                        fontWeight: '800',
                        margin: '0',
                        listStyle: 'none',
                      }}>
                      <li></li>
                    </ul>
                  </div>

                  <div style={{ width: '25%', padding: '10px 16px 14px' }}>
                    <ul
                      style={{
                        padding: '0 0px 20px 2px',
                        color: '#000',
                        fontSize: '14px',
                        fontWeight: '800',
                        margin: '0',
                        listStyle: 'none',
                      }}>
                      <li>{parseFloat(this.state.PolicyAnnualPremium).toFixed(2)}</li>
                    </ul>
                  </div>
                </div>
              ) : ''}
            </div>
          </div>
        </div>
        <div style={{ textAlign: 'right', marginBottom: '10px' }}>
          <button
            className="primary"
            style={{ width: '200px' }}
            onClick={() => this.downloadPdf("divToPrint", "download.pdf")}>
            Download
          </button>
        </div>
      </div>
    )
  }
}

const WrappedViewQuotation = Form.create({ name: 'Homeinsurance_list' })(
  ViewQuotation,
)

export default WrappedViewQuotation
